var checkIdNumber = (function (arr) {
  return function (value) {
    var len = value.length,
      bit = 1,
      sum = 0;

    if (len !== 13) {
      return false;
    }

    while (len--) {
      sum += !(bit ^= 1) ? parseInt(value[len], 10) : arr[value[len]];
    }

    return sum % 10 === 0 && sum > 0;
  };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

export { checkIdNumber };